import React from "react";
import { db } from "../../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import styles from "./VideoList.module.css";

const VideoList = ({ videos, companyId, setVideos }) => {
  if (!videos || Object.keys(videos).length === 0)
    return <p>📭 등록된 영상이 없습니다.</p>;

  // Firestore에서 특정 영상 삭제 함수
  const handleDeleteVideo = async (category, index) => {
    if (!companyId) return;

    try {
      const updatedVideos = { ...videos };

      // 배열이면 해당 영상만 삭제, 아니면 전체 삭제
      if (Array.isArray(updatedVideos[category])) {
        updatedVideos[category].splice(index, 1);

        // 배열이 비었으면 삭제
        if (updatedVideos[category].length === 0) {
          delete updatedVideos[category];
        }
      } else {
        delete updatedVideos[category];
      }

      const companyRef = doc(db, "companies", companyId);
      await updateDoc(companyRef, {
        videos: updatedVideos,
      });

      // 즉시 UI 업데이트
      setVideos(updatedVideos);

      console.log("✅ 영상 삭제 성공!");
    } catch (error) {
      console.error("❌ 영상 삭제 실패:", error);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.videoGrid}>
        {Object.entries(videos).map(([category, urls]) => (
          <div key={category} className={styles.categorySection}>
            <h3>{category.replace(/([A-Z])/g, " $1")}</h3>
            <div className={styles.videoList}>
              {Array.isArray(urls)
                ? urls.map((url, index) => (
                    <div key={index} className={styles.videoCard}>
                      <iframe
                        width="100%"
                        height="200"
                        src={url}
                        title={`${category} ${index + 1}`}
                        frameBorder="0"
                        allowFullScreen
                      ></iframe>
                      <div
                        className={styles.deleteButton}
                        onClick={() => handleDeleteVideo(category, index)}
                      >
                        ❌
                      </div>
                    </div>
                  ))
                : urls && (
                    <div className={styles.videoCard}>
                      <iframe
                        width="100%"
                        height="200"
                        src={urls}
                        title={category}
                        frameBorder="0"
                        allowFullScreen
                      ></iframe>
                      <div
                        className={styles.deleteButton}
                        onClick={() => handleDeleteVideo(category)}
                      >
                        ❌
                      </div>
                    </div>
                  )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoList;
